export default "__VITE_ASSET__CwJvsXkW__"